import React from "react";
import { PageCover } from "../../common/PageCover";

export const HomeCover = () => {
  return (
    <PageCover
      src="/img/cover.jpg"
      backText="OUR"
      frontText="MISSION"
      description="Light Detail Studio's mission is to design and implement functionally-aesthetically balanced spaces tailored to the client's personality traits."
    />
  );
};
